var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemMenuCursorElement_1;
import { P, PCSS, Utils, CustomElement, Watch, ViewChild, PropertyConverters, Components, Defaults, avoidHandler, stopPropagationHandler, CustomElementUtils, Logging } from '@pacem/pacem-core';
//namespace Components.UI {
let PacemMenuElement = class PacemMenuElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this.synchronizeShell = true;
        this._stopPropagationHandlerConditional = (_) => {
            if (!Utils.isNull(this._container) && !Utils.isNull(this._base)) {
                const offsetNav = Utils.offset(this._container);
                const offsetBase = Utils.offset(this._base);
                // TODO: consider height as well for different skins, but DO manage edge cases...
                if (offsetNav.width < offsetBase.width) {
                    this.open = false;
                }
            }
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._container.addEventListener('click', stopPropagationHandler, false);
        this._container.addEventListener("scroll", stopPropagationHandler, false);
        this._sync();
    }
    disconnectedCallback() {
        window.removeEventListener('navigate', this._stopPropagationHandlerConditional, false);
        if (!Utils.isNull(this._container)) {
            this._container.removeEventListener('click', stopPropagationHandler, false);
            this._container.removeEventListener("scroll", stopPropagationHandler, false);
        }
        this._sync(false);
        super.disconnectedCallback();
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('navigate', this._stopPropagationHandlerConditional, false);
        this._shell = CustomElementUtils.findAncestorShell(this);
    }
    _toggle(evt) {
        avoidHandler(evt);
        this.open = !this.open;
        this.dispatchEvent(new Event('toggle'));
    }
    _sync(val = this.open) {
        if (this.synchronizeShell) {
            Utils.addClass(this, 'menu-sync');
            Utils.addClass(this._shell, PCSS + (val === true ? '-menu-open' : '-menu-close'));
            Utils.removeClass(this._shell, PCSS + (val === true ? '-menu-close' : '-menu-open'));
        }
        else {
            Utils.removeClass(this, 'menu-sync');
            Utils.removeClass(this._shell, PCSS + '-menu-close ' + PCSS + '-menu-open');
        }
        if (this.outset) {
            Utils.addClass(this, 'menu-outset');
        }
        else {
            Utils.removeClass(this, 'menu-outset');
        }
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'open' || name === 'synchronizeShell' || name === 'outset') {
            this._sync();
        }
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemMenuElement.prototype, "open", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemMenuElement.prototype, "hideHamburgerButton", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemMenuElement.prototype, "hideBackButton", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMenuElement.prototype, "outset", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemMenuElement.prototype, "synchronizeShell", void 0);
__decorate([
    ViewChild('nav')
], PacemMenuElement.prototype, "_container", void 0);
__decorate([
    ViewChild(`.${PCSS}-menu`)
], PacemMenuElement.prototype, "_base", void 0);
PacemMenuElement = __decorate([
    CustomElement({
        tagName: P + '-menu', template: `<${P}-panel class="${PCSS}-menu" css-class="{{ {'menu-close': !:host.open, 'menu-open': :host.open} }}" on-click=":host._toggle($event)">    
    <nav><${P}-content></${P}-content></nav>
</${P}-panel>
<${P}-shell-proxy>
<${P}-button hide="{{ :host.hideBackButton }}" class="${PCSS}-back ${PCSS}-menu button-flat" css-class="{{ {'menu-close': !:host.open, 'menu-open': :host.open} }}" on-click=":host._toggle($event)">BACK</${P}-button>
<${P}-button hide="{{ :host.hideHamburgerButton }}" class="${PCSS}-hamburger ${PCSS}-menu button-flat" css-class="{{ {'menu-close': :host.open, 'menu-open': !:host.open} }}" on-click=":host._toggle($event)">MENU</${P}-button></${P}-shell-proxy>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemMenuElement);
export { PacemMenuElement };
let PacemMenuCursorElement = PacemMenuCursorElement_1 = class PacemMenuCursorElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this._onPathChange = (evt) => {
            const menu = this._menu, path = (evt && evt.detail) || window.location.pathname;
            if (Utils.isNull(menu)) {
                this.log(Logging.LogLevel.Warn, `Couldn't find a ${PacemMenuElement} ancestor for this ${PacemMenuCursorElement_1}.`);
                return;
            }
            // 1. try to find a matching PacemAnchorElement
            var anchors = menu.querySelectorAll(P + '-a');
            var tget = null;
            for (let j = 0; j < anchors.length; j++) {
                let a = anchors.item(j);
                if (a.href === path) {
                    tget = a;
                    break;
                }
            }
            if (Utils.isNull(tget)) {
                // 2. try with real HTMLAnchorElement
                tget = menu.querySelector(`a[href='${path}']`);
            }
            if (!Utils.isNull(tget)) {
                // TODO: use transforms (remove width/height/top/... animations)
                // TODO: consider <nav> scrollTop
                const rect = Utils.offset(tget);
                const rectMenu = Utils.offset(menu);
                this.style.top = rect.top + 'px';
                this.style.left = rectMenu.left + 'px';
                this.style.width = '0';
                this.style.height = rect.height + 'px';
                Utils.addAnimationEndCallback(this, () => {
                    this.style.width = (rect.width + rect.left - rectMenu.left) + 'px';
                }, 500);
            }
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._menu = CustomElementUtils.findAncestorOfType(this, PacemMenuElement);
        this._onPathChange();
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('navigate', this._onPathChange, false);
    }
    disconnectedCallback() {
        this._menu = null;
        window.removeEventListener('navigate', this._onPathChange, false);
        super.disconnectedCallback();
    }
};
PacemMenuCursorElement = PacemMenuCursorElement_1 = __decorate([
    CustomElement({
        tagName: P + '-menu-cursor'
    })
], PacemMenuCursorElement);
export { PacemMenuCursorElement };
